import type { ReactNode, Ref } from 'react'
import { Avatar } from '@systemeio/components'
import { twMerge } from 'tailwind-merge'

interface CommentLayoutProps {
  userName: string
  userAvatarUrl: string
  level: 0 | 1
  header: ReactNode
  children: ReactNode
  footer: ReactNode
  threadLine?: ReactNode
  className?: string
  scrollRef?: Ref<HTMLDivElement>
}

export function CommentLayout({
  userName,
  userAvatarUrl,
  level,
  header,
  children,
  footer,
  threadLine,
  className,
  scrollRef,
}: CommentLayoutProps): ReactNode {
  return (
    <div
      ref={scrollRef}
      className="flex w-full scroll-mb-[calc(var(--comment-composer-height,0px)+1rem)] flex-row items-start gap-2.5 sm:gap-2.5"
    >
      {threadLine}
      <div className="relative">
        <Avatar
          alt={`Avatar ${userName}`}
          displayName={userName}
          rootProps={{ title: userName }}
          size="lg"
          src={userAvatarUrl || undefined}
        />
        {level > 0 && (
          <div className="absolute top-5 right-[39px] h-px w-[30px] bg-text-secondary/30" />
        )}
      </div>
      <div className="relative w-[calc(100%-40px)] min-w-0 grow-0 rounded-xl">
        <div
          className={twMerge(
            'relative rounded-xl bg-bg-page p-[15px] transition-colors duration-3000 ease-out',
            className,
          )}
        >
          <div className="mb-3 flex items-center justify-between">{header}</div>
          {children}
        </div>
        {footer}
      </div>
    </div>
  )
}
